export const CATALOG_IN_SEGMENTATION_FEATURE_FLAG = 'CatalogInSegmentation';
export const SEGMENTATION_AI_DESCRIPTIONS = 'SegmentationAiDescriptions';
export const MESSAGE_TYPE_SUBSCRIPTION_FEATURE_FLAG = 'MessageTypeSubscription';
export const CATALOG_IN_SEGMENTATION_DYNAMIC_LIST_FEATURE_FLAG = 'CatalogInSegmentationDynamicList';
